import { toast } from "react-toastify";
import { config, errToast, isEmptyPropertyResponse } from "../../utils";
import { handleSiteLoader } from "./authAction";
import sellerSlice from "../slice/sellerSlice";
import { guessDateTime } from "../../utils/dateUtils";
import { parseISO, format } from "date-fns";
import { axiosAuth, axiosUnauth } from "../../utils/axios/axios";
import { sendNotification } from "../../components/notifications/NotificationService";
import { ABUDHABICITYID, ACCOUNT, DOMAIN } from "../../utils/constants";
import { handleSwitchAccount } from "./profileAction";
import {
    setPrincipalRegistrationDocument,
    updateBuyerRegistrationField,
} from "../slice/buyerSlice";
import { encryptWithWebCrypto } from "../../helpers";
export const sellerAction = sellerSlice.actions;
const { error, success } = toast;

export const setFormStep = (step, navigate = null) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSetFormStep(step));
        if (navigate) navigate("/seller/property/");
    };
};

export const uploadSellerPropertyMedia = (
    formData,
    storeData,
    setUploadProgress,
    setShowProgressBar,
    is_Set_Bid_Registration_Doc
) => {
    return async (dispatch) => {
        dispatch(handleSiteLoader(true));
        setShowProgressBar(true);
        try {
            const res = await axiosAuth.post(
                is_Set_Bid_Registration_Doc
                    ? `/api-users/upload-to-bucket/`
                    : `/api-property/seller-upload-property-media/`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent) => {
                        const percent = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setUploadProgress(percent < 90 ? percent : 90);
                    },
                }
            );
            const { data, status } = res;
            if (status === 200) {
                setUploadProgress(100);
                if (data.error === 0) {
                    const { doc_file_name, upload_id } = data?.data || [];
                    if (doc_file_name && upload_id) {
                        storeData.data.doc_file_name = doc_file_name;
                        storeData.data.upload_id = upload_id;
                        dispatch(
                            is_Set_Bid_Registration_Doc
                                ? setPrincipalRegistrationDocument(storeData)
                                : sellerAction.handleSaveStepFourData(storeData)
                        );
                    }
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            setUploadProgress(0);
            dispatch(handleSiteLoader(false));
            setShowProgressBar(false);
        }
    };
};

export const setAuctionFormStep = (step, navigate = null) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleAuctionFormStep(step));
        if (navigate) navigate("/seller/property/");
    };
};

export const fetchListingStatus = () => {
    return async (dispatch, getState) => {
        try {
            const payload = {
                site_id: DOMAIN,
                object_id: 14,
            };

            const response = await axiosAuth.post(
                `/api-settings/lookup-status-listing/`,
                payload,
                config
            );
            const { data, status } = response;
            if (status === 200) {
                if (data.error === 0) {
                    const statusList =
                        data?.data
                            ?.filter(
                                (status) => status.id !== 1 && status.id !== 2
                            )
                            ?.map((status) => ({
                                value: status.id,
                                label: status.status_name,
                            })) ?? [];
                    dispatch(sellerAction.handleSetAuctionStaus(statusList));
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return response.data;
        } catch (err) {
            errToast(err);
        }
    };
};

export const fetchSellerProperties = (
    seller_status = false,
    page_size,
    page
) => {
    return async (_, getState) => {
        try {
            const state = getState();
            const user = state.auth.user?.user_id || null;
            const payload = {
                site_id: DOMAIN,
                source_page: "my_property",
                page_size,
                page,
            };
            if (seller_status) {
                // seller status 9 is for closed tab
                payload[
                    seller_status === 9
                        ? "status"
                        : seller_status === -1
                          ? "filter_all"
                          : "seller_status"
                ] = seller_status === -1 ? "all" : seller_status;
            }
            const response = await axiosAuth.post(
                `/api-property/seller-dashboard-property-listing/`,
                payload,
                config
            );
            return response.data;
        } catch (err) {
            errToast(err);
        }
    };
};

export const fetchSellerAuctions = (activeTab = false, page_size, page) => {
    return async (_, getState) => {
        try {
            const state = getState();
            const user = state.auth.user?.user_id || null;
            const payload = {
                site_id: DOMAIN,
                my_auction: 1,
                page,
                page_size,
            };
            if (activeTab === "1") payload.status = 1;
            if (activeTab !== "1") payload.filter = activeTab;
            const response = await axiosAuth.post(
                `/api-property/seller-dashboard-auction-listing/`,
                payload,
                config
            );
            return response.data;
        } catch (err) {
            errToast(err);
        }
    };
};

export const bidRegistration = (formData) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const state = getState();
        const user = state.auth.user?.user_id || null;
        if (!user && !formData?.property_id) {
            errToast("not authorized to access");
            return;
        }
        try {
            const res = await axiosAuth.post(
                `/api-bid/front-bid-registration/`,
                formData,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    return data?.data || {};
                } else {
                    return false;
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const fetchPropertyDetail = (
    property_id,
    navigate = null,
    detailsPage = false,
    source_page = "",
    isSellerEditPage = false
) => {
    return async (dispatch, getState) => {
        if (!property_id) {
            error("Provide valid PropertyId");
            return;
        }
        const state = getState();
        const isSeller = state.profile.account;
        const user = state.auth.user?.user_id|| state.auth.user?.id || null;
        const isAuthenticated = state.auth.isAuthenticated;
        const publicEncryptionKey = state.auth.publicEncryptionKey;

        if (isSeller === 1 && !user) {
            errToast("Seller ID is required for sellers.");
            return;
        }

        let encryptedAgentId = null;
        if (isSeller === 1 && user && publicEncryptionKey) {
            encryptedAgentId = await encryptWithWebCrypto(
                user,
                publicEncryptionKey
            );
        }
        const payload = {
            property_id,
            ...(source_page && { source_page }),
            ...(user && isSellerEditPage ? { user_id: user } : {}),
            // Conditionally include agent_id only if encryption resolved successfully
            ...(encryptedAgentId && { agent_id: encryptedAgentId }),
        };

        dispatch(handleSiteLoader(true));
        dispatch(sellerAction.handleResetProperty());

        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                !isSellerEditPage
                    ? `/api-property/front-property-detail/`
                    : `/api-property/seller-property-detail/`,
                payload,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const propertyData = data?.data;

                    if (isEmptyPropertyResponse(propertyData)) {
                        const { pathname } = window.location;
                        const account = ACCOUNT.Buyer;
                        dispatch(handleSwitchAccount(account));
                        sessionStorage.setItem("Account", account);
                        window.location.replace(
                            `${pathname.replace(/^\/seller/, "")}`
                        );
                        return res.data;
                    }

                    dispatch(sellerAction.handlePropertyData(propertyData));
                    const {
                        owners = [],
                        tags = [],
                        property_name,
                        property_name_ar,
                        country_id: country,
                        state_id: city,
                        municipality_id: municipality,
                        district_id: district,
                        project_id: project,
                        community,
                        property_type_id: propertyType,
                        building,
                        square_footage: areaSize,
                        beds: numOfBedrooms,
                        baths: numOfBathrooms,
                        number_of_outdoor_parking_spaces: numOfParkings,
                        vacancy,
                        rental_till: rentalTill,
                        construction_status_id: constructionStatus,
                        amenities = [],
                        description,
                        description_ar,
                        property_pic,
                        property_video,
                        property_doc,
                        property_auction_data,
                        deposit_amount,
                        map_url,
                    } = propertyData;

                    if (property_auction_data?.length) {
                        const auction_data = property_auction_data[0];
                        //eslint-disable-next-line
                        const {
                            id,
                            auction_id,
                            start_price,
                            bid_increments,
                            ...rest
                        } = auction_data || {};
                        const auctionStartDate = auction_data.start_date
                            ? typeof auction_data.start_date === "string"
                                ? parseISO(auction_data.start_date)
                                : auction_data.start_date
                            : null;

                        const auctionEndDate = auction_data.end_date
                            ? typeof auction_data.end_date === "string"
                                ? parseISO(auction_data.end_date)
                                : auction_data.end_date
                            : null;
                        dispatch(
                            sellerAction.handleAuctionStepOneData({
                                ...rest,
                                start_price: Number(start_price) || "",
                                bid_increments: Number(bid_increments) || "",
                                buyer_preference: String(
                                    auction_data.buyer_preference || 1
                                ),

                                start_date: auctionStartDate
                                    ? format(auctionStartDate, "yyyy-MM-dd")
                                    : null,
                                start_time: auctionStartDate
                                    ? format(auctionStartDate, "HH:mm")
                                    : null,

                                end_date: auctionEndDate
                                    ? format(auctionEndDate, "yyyy-MM-dd")
                                    : null,
                                end_time: auctionEndDate
                                    ? format(auctionEndDate, "HH:mm")
                                    : null,

                                deposit_amount: Number(deposit_amount) || "",
                            })
                        );
                    }
                    dispatch(
                        sellerAction.handleSaveStepOneData(
                            owners.map((item) => ({
                                ...item,
                                nationality: item.owner_nationality,
                            }))
                        )
                    );
                    dispatch(
                        sellerAction.handleSaveStepTwoData({
                            property_name,
                            property_name_ar,
                            country,
                            city,
                            municipality,
                            district,
                            project,
                            community,
                            propertyType,
                            building,
                            map_url,
                        })
                    );
                    dispatch(
                        sellerAction.handleSaveStepThreeData({
                            areaSize,
                            numOfBedrooms,
                            numOfBathrooms,
                            numOfParkings,
                            vacancy: `${vacancy}`,
                            rentalTill: rentalTill
                                ? guessDateTime(
                                      new Date(rentalTill),
                                      "YYYY-MM-DD"
                                  )
                                : null,
                            constructionStatus: constructionStatus,
                            amenities: amenities.map(
                                ({ feature_id, feature_name }) => {
                                    return {
                                        label: feature_name,
                                        value: "" + feature_id,
                                    };
                                }
                            ),
                            tags: tags.map(({ value, label }) => ({
                                label,
                                value: String(value),
                            })),
                            description,
                            description_ar,
                        })
                    );
                    if (property_video?.length > 0) {
                        dispatch(
                            sellerAction.handleSaveStepFourData({
                                section: "gallery",
                                property: "video",
                                operation: "add",
                                data: property_video[0],
                                index: null,
                            })
                        );
                    }
                    const coverImage = property_pic?.filter(
                        (item) => item.upload_identifier === 1
                    );
                    const propertyImage = property_pic?.filter(
                        (item) => item.upload_identifier === 2
                    );
                    if (coverImage?.length > 0) {
                        dispatch(
                            sellerAction.handleSaveStepFourData({
                                section: "gallery",
                                property: "coverImage",
                                operation: "add",
                                data: coverImage[0],
                                index: null,
                            })
                        );
                    }
                    propertyImage?.map((image) => {
                        dispatch(
                            sellerAction.handleSaveStepFourData({
                                section: "gallery",
                                property: "propertyImage",
                                operation: "add",
                                data: image,
                                index: null,
                            })
                        );
                    });
                    const titleDeed = property_doc?.filter(
                        (item) => item.upload_identifier === 4
                    );
                    if (titleDeed?.length > 0) {
                        dispatch(
                            sellerAction.handleSaveStepFourData({
                                section: "documents",
                                property: "titleDeed",
                                operation: "add",
                                data: titleDeed[0],
                                index: null,
                            })
                        );
                    }
                    const floorPlans = property_doc?.filter(
                        (item) => item.upload_identifier === 3
                    );
                    if (floorPlans?.length > 0) {
                        dispatch(
                            sellerAction.handleSaveStepFourData({
                                section: "documents",
                                property: "floorPlans",
                                operation: "add",
                                data: floorPlans[0],
                                index: null,
                            })
                        );
                    }
                    const inspectionReport = property_pic?.filter(
                        (item) => item.upload_identifier === 6
                    );
                    if (inspectionReport?.length > 0) {
                        dispatch(
                            sellerAction.handleSaveStepFourData({
                                section: "gallery",
                                property: "inspectionReport",
                                operation: "add",
                                data: inspectionReport[0],
                                index: null,
                            })
                        );
                    }
                    const valuationReport = property_pic?.filter(
                        (item) => item.upload_identifier === 7
                    );
                    if (valuationReport?.length > 0) {
                        dispatch(
                            sellerAction.handleSaveStepFourData({
                                section: "gallery",
                                property: "valuationReport",
                                operation: "add",
                                data: valuationReport[0],
                                index: null,
                            })
                        );
                    }
                    if (municipality)
                        dispatch(
                            setDistricts({ municipality_id: municipality })
                        );
                    if (Number(city) === ABUDHABICITYID && district)
                        dispatch(setCommunitys({ district_id: district }));
                    dispatch(sellerAction.handleSetFormStep(1));
                    if (navigate) navigate("/seller/property/");
                } else {
                    if (
                        `${data?.msg}`.toLocaleLowerCase() ===
                        "Permission denied.".toLocaleLowerCase()
                    ) {
                        dispatch(handleSwitchAccount(ACCOUNT.Buyer));
                        sessionStorage.setItem("Account", ACCOUNT.Buyer);

                        if (!isSellerEditPage) {
                            sessionStorage.setItem(
                                "accountSwitchedToBuyer",
                                "1"
                            );
                            window.location.replace(
                                window.location.pathname.replace(
                                    /^\/seller/,
                                    ""
                                )
                            );
                            return res.data;
                        }
                    }
                    `${data?.msg}`.toLocaleLowerCase() !==
                        "Access Denied.".toLocaleLowerCase() && error(data.msg);
                    if (navigate && detailsPage) navigate("/not-found");
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const setCountries = () => {
    return async (dispatch) => {
        // dispatch(handleSiteLoader(true));
        try {
            const res = await axiosAuth.post(
                `/api-settings/get-country/`,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const countries =
                        data?.data?.map((country) => ({
                            value: country.id,
                            label: country.country_name,
                            iso_name: country.iso_name,
                        })) ?? [];
                    dispatch(sellerAction.handleSetCountries(countries));
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            // dispatch(handleSiteLoader(false));
        }
    };
};

export const setCities = (payload = {}) => {
    return async (dispatch, getState) => {
        const { country_id = null } = payload;

        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;
        const registrationType =
            state.buyer?.buyerRegistration?.registrationType;

        // dispatch(handleSiteLoader(true));

        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                `/api-settings/get-state/`,
                country_id ? { country_id } : undefined,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const cities =
                        data?.data?.map((city) => ({
                            value: city.id,
                            label: city.state_name,
                            state_name: city.state_name,
                        })) ?? [];

                    if (!registrationType) {
                        dispatch(sellerAction.handleSetCities(cities));
                    } else {
                        dispatch(
                            updateBuyerRegistrationField({
                                section: registrationType,
                                stepKey: "stepOneData",
                                value: { cityList: cities },
                            })
                        );
                    }
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            // dispatch(handleSiteLoader(false));
        }
    };
};

export const setMunicipalities = (formData) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const isAuthenticated = getState().auth.isAuthenticated;

        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                `/api-settings/get-munciplity/`,
                formData,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const municipalities =
                        data?.data?.map((municipality) => ({
                            value: municipality.id,
                            label: municipality.municipality_name,
                            label_ar: municipality.municipality_name_ar,
                        })) ?? [];
                    dispatch(
                        sellerAction.handleSetMunicipalities(municipalities)
                    );
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const setDistricts = (formData) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;
        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                `/api-settings/get-district/`,
                formData,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const districts =
                        data?.data?.map((district) => ({
                            value: district.id,
                            label: district.district_name,
                            label_ar: district.district_name_ar,
                        })) ?? [];
                    dispatch(sellerAction.handleSetDistricts(districts));
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const setCommunitys = (formData) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;
        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                `/api-settings/get-community/`,
                formData,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const communities =
                        data?.data?.map((community) => ({
                            value: community.community_name,
                            label: community.community_name,
                            label_ar: community.community_name_ar,
                        })) ?? [];
                    dispatch(sellerAction.handleSetCommunitys(communities));
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

let projectAbortController = null;

export const setProjects = (
    municipality_id = "",
    district_id = "",
    community_id = ""
) => {
    return async (dispatch, getState) => {
        // ✅ Cancel previous request
        if (projectAbortController) {
            projectAbortController.abort();
        }

        // ✅ Create new controller
        projectAbortController = new AbortController();

        dispatch(handleSiteLoader(true));

        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;

        const payload = {
            ...(municipality_id && { municipality_id }),
            ...(district_id && { district_id }),
            ...(community_id && { community_id }),
        };

        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                `/api-settings/project-list/`,
                payload,
                {
                    ...config,
                    signal: projectAbortController.signal, // ✅ attach signal
                }
            );

            const { data, status } = res;

            if (status === 200 && data.error === 0) {
                const projects =
                    data?.data?.map((project) => ({
                        value: project.id,
                        label: project.project_name,
                    })) ?? [];

                dispatch(sellerAction.handleSetProjects(projects));
            } else {
                error(data.msg);
            }

            return res.data;
        } catch (err) {
            if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
                return;
            }

            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const setAmenities = () => {
    return async (dispatch) => {
        dispatch(handleSiteLoader(true));
        try {
            const res = await axiosAuth.post(
                "/api-project/get-facility/",
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const amenities =
                        data?.data?.map((amenities) => ({
                            value: "" + amenities.id,
                            label: amenities.name,
                        })) ?? [];
                    dispatch(sellerAction.handleSetAmenities(amenities));
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const setTags = () => {
    return async (dispatch) => {
        dispatch(handleSiteLoader(true));
        try {
            const res = await axiosAuth.post("/api-settings/get-tags/", config);
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const tags =
                        data?.data?.map((tags) => ({
                            value: "" + tags.id,
                            label: tags.tag,
                        })) ?? [];
                    dispatch(sellerAction.handleSetTags(tags));
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

let propertyTypeController;

export const setPropertyType = () => {
    return async (dispatch, getState) => {
        const isAuthenticated = getState().auth.isAuthenticated;

        if (propertyTypeController) {
            propertyTypeController.abort();
        }

        propertyTypeController = new AbortController();

        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                `/api-settings/get-property-type/`,
                config,
                {
                    signal: propertyTypeController.signal,
                }
            );

            const { data, status } = res;

            if (status === 200) {
                if (data.error === 0) {
                    const propertyTypes =
                        data?.data?.map((property) => ({
                            value: property.id,
                            label: property.property_type,
                        })) ?? [];

                    dispatch(sellerAction.handleSetPropertyType(propertyTypes));
                } else {
                    error(data.msg);
                }
            } else {
                error(data.msg);
            }

            return res.data;
        } catch (err) {
            if (err.name === "CanceledError" || err.name === "AbortError") {
                return;
            }
            errToast(err);
        }
    };
};
export const setConstructionStatus = () => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const isAuthenticated = getState().auth.isAuthenticated;
        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                `/api-settings/lookup-status-listing/`,
                { object_id: 26 },
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const constructionStatus =
                        data?.data?.map((construction) => ({
                            value: construction.id,
                            label: construction.status_name,
                        })) ?? [];
                    dispatch(
                        sellerAction.handleSetConstructionStatus(
                            constructionStatus
                        )
                    );
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const setPropertyCity = (city) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSetPropertyCity(city));
    };
};

export const saveStepOneData = (data) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSaveStepOneData(data));
    };
};

export const saveStepTwoData = (data) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSaveStepTwoData(data));
    };
};

export const saveStepThreeData = (data) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSaveStepThreeData(data));
    };
};

export const saveStepFourData = (data) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSaveStepFourData(data));
    };
};

export const addNewProjectOption = (data) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleAddNewProjectOption(data));
    };
};

export const resetProperty = (data) => {
    return async (dispatch) => {
        dispatch(sellerAction.handleResetProperty(data));
    };
};

export const resetDistricts = () => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSetDistricts([]));
    };
};

export const resetCommunitys = () => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSetCommunitys([]));
    };
};

export const resetProjects = () => {
    return async (dispatch) => {
        dispatch(sellerAction.handleSetProjects([]));
    };
};

export const saveProperty = (formData, navigate = null) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        try {
            const state = getState();
            const res = await axiosAuth.post(
                `/api-property/add-property-seller/`,
                {
                    site_id: DOMAIN,
                    ...formData,
                },
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    success(data.msg);
                    sendNotification();
                    if (navigate && !formData.property_id) {
                        navigate("/seller/property/success/");
                    } else {
                        navigate("/my-properties/");
                    }
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const saveAuction = (formData, navigate = null) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        try {
            const state = getState();
            const res = await axiosAuth.post(
                `/api-property/add-property-seller/`,
                {
                    site_id: DOMAIN,
                    ...formData,
                },
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    success(data.msg);
                    formData?.step === 2 && sendNotification();
                } else {
                    error(data.msg);
                }
                if (navigate && !data.error)
                    navigate("/seller/property/success/");
            } else error(data.msg);
            dispatch(handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(handleSiteLoader(false));
        }
    };
};

export const movePropertyToAuction = (property_id) => {
    return async (dispatch) => {
        dispatch(handleSiteLoader(true));
        try {
            const res = await axiosAuth.post(
                `/api-property/move-property-to-auction/`,
                { property_id },
                config
            );
            dispatch(handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(handleSiteLoader(false));
        }
    };
};

export const togglePropertyLike = (formData) => {
    return async (dispatch, getState) => {
        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;
        try {
            const { status, data } = await (
                isAuthenticated ? axiosAuth : axiosUnauth
            ).post(`/api-property/make-favourite-property/`, formData, config);
            if (status === 200 && data.error === 0) sendNotification();
            return { status, data };
        } catch (err) {
            errToast(err);
        }
    };
};

export const buyNowProperty = (property_id) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const state = getState();
        const user_id = state.auth.user?.user_id || null;
        try {
            const { status, data } = await axiosAuth.post(
                `/api-property/buy-now-property/`,
                { property_id, user_id, site_id: DOMAIN },
                config
            );
            if (status === 200) {
                if (data.error === 0) {
                    success(data.msg);
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return { status, data };
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const StartPurchaseOrForefitProperty = (
    property_id,
    process_type = 1,
    forefit_signature = ""
) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        try {
            const { status, data } = await axiosAuth.post(
                `/api-bid/start-purchase-or-forefit-property/`,
                {
                    property_id,
                    site_id: DOMAIN,
                    process_type,
                    ...(process_type === 2 && { accept_forfeit_term: 1 }),
                    ...(forefit_signature &&
                        process_type === 2 && {
                            forefit_signature,
                        }),
                },
                config
            );
            if (status === 200) {
                if (data?.error === 0) {
                    success(data?.msg);
                } else {
                    error(data?.msg);
                }
            } else error(data?.msg);
            return { status, data };
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const fetchSimilarProperties = ({
    property_id,
    page = 1,
    page_size = 3,
}) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const isAuthenticated = state.auth.isAuthenticated;
            const payload = {
                property_id,
                domain_id: DOMAIN,
                page,
                page_size,
            };
            const response = await (
                isAuthenticated ? axiosAuth : axiosUnauth
            ).post(`/api-property/similar-property/`, payload, config);
            const { data, status } = response;
            if (status === 200) {
                if (data.error === 0) {
                    dispatch(
                        sellerAction.handleSimilarProperty(data?.data?.data)
                    );
                } else {
                    return false;
                }
            } else error(data.msg);
            return response.data;
        } catch (err) {
            errToast(err);
        }
    };
};

export const relistingProperty = (formData) => {
    return async (dispatch, getState) => {
        try {
            dispatch(handleSiteLoader(true));
            const response = await axiosAuth.post(
                `/api-property/property-relist/`,
                formData,
                config
            );
            const { data, status } = response;
            if (status === 200) {
                if (data.error === 0) {
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return response.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const createAuction = (propertyId) => async (dispatch, getState) => {
    try {
        const api = getState().auth?.isAuthenticated ? axiosAuth : axiosUnauth;

        const { status, data } = await api.post(
            "/api-property/create-auction/",
            { property_id: propertyId, site_id: DOMAIN },
            config
        );

        if (status !== 200 || data?.error !== 0) {
            error(data?.msg || "Something went wrong");
            return null;
        }

        const auctionId = data?.data?.auction_id;

        if (auctionId) {
            dispatch(
                sellerAction.handlePropertyData({ auction_id: auctionId })
            );
        }

        return auctionId;
    } catch (err) {
        errToast(err);
        return null;
    }
};

export const saveSellerPurchaseAgreement = (formData) => {
    return async (dispatch, getState) => {
        try {
            const res = await axiosAuth.post(
                `/api-property/save-seller-purchase-agreement/`,
                formData,
                config
            );
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
        }
    };
};

export const getBedsOption = (propertyType = "") => {
    return async (dispatch) => {
        dispatch(handleSiteLoader(true));
        try {
            const res = await axiosAuth.post(
                "/api-settings/property-layout/",
                { ...(propertyType && { propertyType }) },
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const beds =
                        data?.data?.map((bed) => ({
                            value: bed.layout,
                            label: bed.layout,
                        })) ?? [];
                    dispatch(sellerAction.handleSetBeds(beds));
                } else {
                    error(data.msg);
                }
            } else error(data.msg);
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};
